import "./index.css";

import Navigation from './components/Navigation'
import HeroSection from "./components/HeroSection";
import BackgroundSection from './components/BackgroundSection'
import CurrentlySection from "./components/CurrentlySection";
import WorkSection from './components/WorkSection'
import Footer from "./components/Footer";

export default function App() {
  return (
    <div className="app">
      <a href="#main" className="skip-link">Skip to main content</a>
      <Navigation />
      <main id="main">
        <HeroSection />
        <CurrentlySection />
        <WorkSection />
        <BackgroundSection />
      </main>
      <Footer />
    </div>
  );
}
